import { IPublishTerms } from './publishTerms';

export interface IPublishTermsState extends IPublishTerms {
  /** Статус загрузки услуг размещения */
  status: EPublishTermsStatus;
  /** Статус перезагрузки услуг размещения */
  isServicesReloading: boolean;
  /** Ошибка сервера */
  error: string | null;
  /** Флаг инициатора смена типа размещения */
  isPlacingTypeChangedByUser: boolean;
}

export enum EPublishTermsStatus {
  initial = 'initial',
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}
